import { Theme, Typography } from '@mui/material';
import styled from 'styled-components';

interface RankProps {
  $rank: number;
}

interface CurrentUserProps {
  $isCurrentUser: boolean;
}

const getRankColour = (
  theme: Theme, $rank: number) => {
  if ($rank === 1) return theme.palette.yellow.main;
  if ($rank === 2) return theme.palette.gray.light;
  if ($rank === 3) return theme.palette.orange.main;
  return theme.palette.darkPrimary.main;
};

const StyledCard = styled.div<CurrentUserProps>`
  background-color: ${({ theme, $isCurrentUser }) => ($isCurrentUser ? theme.palette.backdrop.main : theme.palette.backdrop.light)};
  border-radius: ${({ theme }) => theme.shape.borderRadius * 2}px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(1)};
`;

const RankTypography = styled(Typography)<RankProps>`
  && {
    color: ${({ theme, $rank }) => getRankColour(theme, $rank)};
    width: 24px;
    display: flex;
    align-items: center;
  }
`;

export { StyledCard, RankTypography };
